<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g
            id="_9023675_instagram_logo_fill_icon"
            data-name="9023675_instagram_logo_fill_icon"
            transform="translate(0 0)">
            <ellipse
                id="Ellipse_24"
                data-name="Ellipse 24"
                cx="3.84"
                cy="3.84"
                rx="3.84"
                ry="3.84"
                transform="translate(8.16 8.16)" />
            <path
                id="Path_162"
                data-name="Path 162"
                d="M45.28,28H34.72A6.72,6.72,0,0,0,28,34.72V45.28A6.72,6.72,0,0,0,34.72,52H45.28A6.72,6.72,0,0,0,52,45.28V34.72A6.72,6.72,0,0,0,45.28,28ZM40,45.76A5.76,5.76,0,1,1,45.76,40,5.76,5.76,0,0,1,40,45.76ZM46.24,35.2a1.44,1.44,0,1,1,1.44-1.44A1.44,1.44,0,0,1,46.24,35.2Z"
                transform="translate(-28 -28)" />
        </g>
    </svg>
</template>
